import { render } from "./QRCollector.vue?vue&type=template&id=f4acc042&scoped=true"
import script from "./QRCollector.vue?vue&type=script&lang=js"
export * from "./QRCollector.vue?vue&type=script&lang=js"

import "./QRCollector.vue?vue&type=style&index=0&id=f4acc042&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4acc042"]])

export default __exports__